// Classes
import MediaRequest from "./MediaRequest.js"; // Enums
import { Cipher, MediaRequestType } from "./types.js";
export default class PreviewRequest extends MediaRequest {
  constructor() {
    super([{
      cipher: Cipher.NONE,
      format: 'MP3_128'
    }]);
    this.type = MediaRequestType.PREVIEW;
  }
}
//# sourceMappingURL=PreviewRequest.js.map